// TECH-DEBT: no test file — parseDecimal and normalizeFiat are pure functions and
// high-value targets for unit tests (all data parsing flows through parseDecimal).
import { ALL_FIAT_CODES, Fiat, NumericLike } from "./types";

/**
 * Parses numeric strings or numbers into a strict number, or null if invalid.
 */

export const parseDecimal = (value: NumericLike): number | null => {
  if (value === null || value === undefined) {
    return null;
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

/**
 * Normalizes an unknown currency string to the supported Fiat union if valid.
 */
export const normalizeFiat = (value: unknown): Fiat | null => {
  if (typeof value !== "string") return null;
  const upper = value.toUpperCase();
  if ((ALL_FIAT_CODES as string[]).includes(upper)) {
    return upper as Fiat;
  }
  return null;
};
